import { useGetParams } from '../../hooks/useGetParams';

import styles from './BgVideo.module.css';

import posterDefault from '../../assets/images/bgPoster.webp';
import bgDefaultVideo from '../../assets/video/bgVideo.webm';

export const BgVideo = () => {
  const { bgVideo, bgPoster } = useGetParams();
  return (
    <>
      {bgVideo && (
        <video
          autoPlay="autoplay"
          muted="muted"
          loop
          poster={bgVideo === '1' ? posterDefault : bgPoster}
          className={styles.bgVideo}
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          ></source>
        </video>
      )}
    </>
  );
};
